import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { novoDB, triggerLoadNovoDB } from "../dbs/dbsSlice";
import { burn, carregaLivrudoDB } from "./LivrudoSlice";
import { Sheet, Typography, Divider, Stack, Grid, Button, Table } from '@mui/joy';
import { UnpublishedOutlined } from "@mui/icons-material";


function DetalheLivroPage() {

    let { id } = useParams();
    var dispatch = useDispatch();
    var dbs = useSelector((state) => state.dbs.dbs)
    var loaded = false

    if (Object.keys(dbs).includes("livrudo")) {
        loaded = dbs.livrudo.loaded
    }

    React.useEffect(() => {
        dispatch(triggerLoadNovoDB(
            novoDB("livrudo", 10, "db", (p) => {

                var db = p.payload
                var versao = p.versao

                dispatch(carregaLivrudoDB(db != null ? db : {}))
            })
        ))
    }, []);

    var livros = useSelector(state => state.livrudo.db.livros)
    var skus = useSelector(state => state.livrudo.db.skus)
    var estados = useSelector(state => state.livrudo.db.estados)

    console.log(skus)
    console.log(estados)

    var livro = livros.filter(f => f.id == id)
    var unidades = skus.filter(s => s.livroId == id)

    if (livro.length == 0) {
        return "Livro não encontrado"
    }

    livro = livro[0]

    return <>
        {/* <pre>{JSON.stringify(livro, null, 2)}</pre> */}
        <Grid container sx={{ padding: "10px" }
        }>
            <Stack width="100%" spacing={1}>
                <Grid xs={12}>
                    <DadosGerais livro={livro} />
                </Grid>
                <Grid xs={12}>
                    <DadosCompra livro={livro} unidades={unidades} />
                </Grid>
            </Stack>
        </Grid>
    </>
}

function DadosCompra(props) {
    var livro = props.livro
    var unidades = props.unidades
    var dispatch = useDispatch()
    return <Sheet
        variant="outlined"
        sx={{
            margin: 'auto',
            padding: 2,
            borderRadius: 'md',
            boxShadow: 'lg',
            backgroundColor: 'neutral.softBg',
        }}
    >


        {/* <Button onClick={() => dispatch(burn())}> burn </Button> */}
        <Link to={"/livrudo/livros/" + livro.id + "/add-compra"}>
            <Button> Adicionar compra </Button>
        </Link>
        <Table size="md" aria-label="striped table" stripe="2n" >
            <thead>
                <tr>
                    <th>SKU</th>
                    <th>Data</th>
                    <th>Plataforma</th>
                    <th>Condição</th>
                    <th>Custo Aq.</th>
                    <th>Venda</th>
                    <th>Resultado</th>
                    <th>Lucro/Retorno</th>
                    <th>Estado</th>
                </tr>
            </thead>
            <tbody>
                {unidades
                    .map((row) => (
                        <tr key={row.sku}>
                            <td>
                                <Link to={"/livrudo/skus/" + row.sku}>
                                    {row.sku}
                                </Link>
                            </td>
                            <td>{row.data}</td>
                            <td>{row.plataforma}</td>
                            <td>{row.condicao}<br />{row.observacao}</td>
                            <td>R$ {row.preco}</td>
                            <td>
                                {typeof (row.venda) == "undefined" || row.venda == null ?
                                    <Link to={"/livrudo/livros/" + livro.id + "/sku/" + row.sku + "/vender"}>
                                        <Button color="danger">Vender</Button>
                                    </Link> : row.venda.data}
                            </td>
                            <td>
                                {typeof (row.venda) == "undefined" || row.venda == null ? "----" : "Venda: R$ " + (parseFloat(row.venda.preco).toFixed(2))}<br />
                                {typeof (row.venda) == "undefined" || row.venda == null ? "----" : "Custos: R$ " + (parseFloat(row.venda.tarifa)).toFixed(2)}<br />
                                {typeof (row.venda) == "undefined" || row.venda == null ? "----" : "Liquido: R$ " + (parseFloat(row.venda.preco) - parseFloat(row.venda.tarifa)).toFixed(2)}
                               
                            </td>
                            <td>{typeof (row.venda) == "undefined" || row.venda == null ? "----" : "R$ " + row.venda.lucro.toFixed(2) + " (" + (row.venda.retorno * 100).toFixed(2) + "%)"}</td>
                            <td>{row.ultimoEstado}</td>
                        </tr>
                    ))}
            </tbody>
        </Table>
    </Sheet>
}

function DadosGerais(props) {
    var livro = props.livro
    return <Sheet
        variant="outlined"
        sx={{
            margin: 'auto',
            padding: 2,
            borderRadius: 'md',
            boxShadow: 'lg',
            backgroundColor: 'neutral.softBg',
        }}
    >
        <Typography level="h4" textAlign="center" mb={1}>
            Informações do Livro
        </Typography>
        <Divider sx={{ marginBottom: 2 }} />
        <Stack spacing={1.5}>
            <Typography><strong>ID:</strong> {livro.id}</Typography>
            <Typography><strong>Nome:</strong> {livro.nome}</Typography>
            <Typography><strong>ISBN:</strong> {livro.isbn}</Typography>
            <Typography><strong>Editora:</strong> {livro.editora}</Typography>
            <Typography><strong>Tipo:</strong> {livro.tipo}</Typography>
            <Typography><strong>Categoria:</strong> {livro.categoria}</Typography>
            <Typography><strong>Data:</strong> {livro.data}</Typography>
        </Stack>
    </Sheet>
}

export default DetalheLivroPage